






















































































import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class SsoCakismaDialog extends Vue {
  @Prop({default: false}) acik!: boolean;
  @Prop({default: null}) cakisma!: any;
  @Prop({default: () => ({})}) adayLisanslari!: any;
  @Prop({default: null}) secilenAdayId!: number | null;
  @Prop({default: false}) kurumMu!: boolean;
  @Prop({default: ""}) yeniEposta!: string;
  @Prop({default: ""}) yeniKimlikNo!: string;
  @Prop({default: false}) saving!: boolean;
}
